const INITIAL_STATE = {
    "_id" : "",
    "userId": "",
    "authToken": "",
    "firstName" : "",
    "lastName" : "",
    "profilePicture": "",
    "rememberMe" : false,
    "isLoggedIn" : null,
    "rights" : null,
}

export default function (state = INITIAL_STATE, action) {
    
    switch (action.type) {
        case "UPDATE_BASIC_DETAILS":
        return {
            ...state,
            ...action.payload
        }
        case "FETCH_USER_DETAILS" : 
        return {...state}
        
        case 'UPDATE_RIGHTS':
        return{
                ... state,
                ...{ rights : action.payload }
        }
        case "SIGN_OUT":
            return {...INITIAL_STATE,isLoggedIn : false}
            
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/main.js